// extracted by mini-css-extract-plugin
export var label = "_fv-2";
export var slideContainer = "_fv-0";
export var slider = "_fv-1";